import './multiSelect.scss';

import React from 'react';
import classnames from 'classnames'
import { isEqual } from 'lodash';
import { Translate, withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import DropdownTreeSelect from '../common/DropdownTree/index'
import { getNested, isNullOrUndefined } from '../../store/storeFunctions';

class MultiSelect extends React.Component {

    static defaultProps = {
        readOnly: false
    }

    constructor(props) {
        super(props);
        const { data, map, parentMap, isRequesting } = this.processNewData(this.getDomainData());
        this.state = { data: { hierarchy: data, map: map, parentMap: parentMap }, isRequesting, selection: null };
        this.button = React.createRef();

    }

    getDomainData = () => {

        if (this.props.customDomain)
            return { requestResult: this.props.customDomain, isRequesting: false }
        else
            return this.props.data.indexOf('.') === -1 ? this.props[this.props.data] : getNested(this.props, this.props.data);
    }

    componentDidMount() {
        let checkedNodes = 0;
        this.state.data.hierarchy.forEach(parent => {
            checkedNodes += parent.children.filter(node => !isNullOrUndefined(node.checked) && node.checked !== false && (node.children.length === 0 || this.props.splitOnlyParent)).length;
        })

        this.disableButton(checkedNodes);
    }

    componentDidUpdate() {
        if (this.state.isRequesting && !this.getDomainData().isRequesting) {
            const { data, map, parentMap, isRequesting } = this.processNewData(this.getDomainData());
            this.setState({ data: { hierarchy: data, map: map, parentMap: parentMap }, isRequesting });

        }
        else if (this.props.forceUpdate === true && !this.getDomainData().isRequesting) {
            const { data, map, parentMap, isRequesting } = this.processNewData(this.getDomainData());
            // Check if domain data changed by investigating data keys
            if (this.state.selection !== this.props.selection ||
                !isEqual(this.state.data.hierarchy.map(x => x.value).sort(), data.map(x => x.value).sort()) ||
                !isEqual(Object.keys(this.state.data.map).sort(), Object.keys(map).sort()) ||
                !isEqual(Object.keys(this.state.data.parentMap).sort(), Object.keys(parentMap).sort()))
                this.setState({ data: { hierarchy: data, map: map, parentMap: parentMap }, isRequesting, selection: this.props.selection });
        }
    }

    processNewData = (domainData) => {
        let clonedData = [];
        this.cloneData(domainData.requestResult, clonedData);
        return this.parseData(clonedData, this.props.selection.all, domainData.isRequesting);
    }

    headerStyle = () => {
        let stl = { display: 'flex', flexDirection: 'column', lineHeight: '2.5em' };
        if (this.state.isRequesting) { stl['width'] = '100%'; }
        return stl;
    }

    render() {
        return (
            <div className='multi-select-popup-content'>
                <div className={classnames('multi-select-wrapper', { 'multi-select-wrapper-padding': this.props.paddingLeft })}>
                    {(this.state.isRequesting === false) && (
                        <div className={classnames({ 'popup-multiselect': this.props.isInPopup })} >
                            <DropdownTreeSelect
                                data={this.state.data.hierarchy} keepTreeOnSearch={true}
                                texts={{ placeholder: this.props.translate("Search.Bankruptcy.SearchForm.Search"), noMatches: ' ' }} showDropdown='always'
                                onChange={this.onChange}
                                hasRadioButtons={this.props.hasRadioButtons}
                                onNodeToggle={this.handleNodeToggle} showPartiallySelected={!this.props.splitParentAndChild && !this.props.splitOnlyParent}
                                mode={this.props.splitParentAndChild || this.props.splitOnlyParent ? "hierarchical" : undefined} forceToggleChildren={this.props.splitOnlyParent}
                                name={this.props.name} onSelectDeselectAllChange={this.onSelectDeselectAllChange} readOnly={this.props.readOnly} disableSelectAll={this.props.disableSelectAll} showCustomError={this.props.showCustomError} 
                                />
                        </div>
                    )}
                </div>
                {!this.props.isFinancialModal &&
                    <div className='multi-select-btns'>
                        <div className='ok-btn'>
                            <div className='control'>
                                <button ref={this.button} className={classnames('bb-button gradient-1', { 'is-square': localStorage.locales_button_style === 'square' })} onClick={() => this.props.ok()}
                                 disabled={this.props.readOnly }>
                                    <Translate id="Common.Select" />
                                </button>
                            </div>
                        </div>
                    </div>
                }
            </div>
        )
    }

    disableButton = (checkedNodes) => {
        if (!isNullOrUndefined(this.button) && !isNullOrUndefined(checkedNodes) && !isNullOrUndefined(this.props.maxSelectedNodes)) {
            if (!isNullOrUndefined(this.button.current)) {
                let button = this.button.current;
                if (checkedNodes > this.props.maxSelectedNodes) {
                    button.disabled = true;
                } else {
                    button.disabled = false;
                }
            }
        }
    }

    cloneData = (data, clonedData) => {
        if (Array.isArray(data)) {
            data.forEach(i => {
                let itemClone = { ...i };
                clonedData.push(itemClone);
                itemClone.children = [];
                this.cloneData(i.children, itemClone.children);
            });
        }
    }

    parseData = (data, selected, isRequesting) => {
        if (data.length > 0) {
            let map = {};
            this.constructMap(data, map);
            let parentMap = this.constructParentMap(map);
            this.applySelected(map, parentMap, selected);

            if (this.props.treeExpanded) {
                this.initAllExpanded(parentMap);
            }
            else {
                this.initInnerExpanded(map);
            }

            return { map: map, data: data, parentMap: parentMap, isRequesting };
        } else {
            return { map: {}, data: [], parentMap: {}, isRequesting };
        }
    }

    constructMap = (data, map) => {
        if (Array.isArray(data)) {
            data.forEach(i => {
                map[i.value] = i;
                this.constructMap(i.children, map);
            });
        }
    }

    constructParentMap = (map) => {
        let parentMap = {};
        Object.keys(map).forEach(i => {
            let parent = map[i];
            if (parent.children) {
                parent.children.forEach(child => {
                    parentMap[child.value] = parent;
                });
            }
        });
        return parentMap;
    }

    applySelected = (map, parentMap, selected) => {
        selected.forEach(i => {
            let toSelect = map[i.value];

            // Some data may not be present if domain data have changed
            if (!isNullOrUndefined(toSelect)) {
                toSelect.checked = true;
                let currentParent = parentMap[toSelect.value];
                while (currentParent) {
                    currentParent.expanded = true;
                    currentParent = parentMap[currentParent.value];
                }
            }
        });
    }

    initAllExpanded = (values) => {
        Object.keys(values).forEach(i => {
            if (!i.startsWith('IN02')) {
                values[i].innerExpanded = values[i].expanded = true;
            }
        });
    }

    initInnerExpanded = (map) => {
        Object.keys(map).forEach(i => {
            map[i].innerExpanded = map[i].expanded;
        });
    }

    onChange = (currentNode, selectedNodes) => {
        let changedNode = this.state.data.map[currentNode.value];
        changedNode.checked = currentNode.checked;

        if (!this.props.splitParentAndChild || this.props.splitOnlyParent) {
            this.updateSubnodes(this.state.data.map[currentNode.value].children, currentNode.checked);
        }

        if (!currentNode.checked && !this.props.splitOnlyParent) {
            let currentParent = this.state.data.parentMap[currentNode.value];
            while (currentParent) {
                currentParent.checked = false;
                currentParent = this.state.data.parentMap[currentParent.value];
            }
        }

        let allSelectedNodes = [];
        this.populateAllSubnodes(selectedNodes.map(node => this.state.data.map[node.value]), allSelectedNodes);
        let checkedNodes = allSelectedNodes.filter(node => node.checked !== false && (node.children.length === 0 || this.props.splitOnlyParent));

        this.disableButton(checkedNodes.length);
        this.props.handleChange(checkedNodes, []);
    }

    updateSubnodes(nodes, value) {
        if (Array.isArray(nodes)) {
            nodes.forEach(node => {
                node.checked = this.props.hasRadioButtons && node.isDefault === false ? false : value;
                this.updateSubnodes(node.children, value);
            });
        }
    }

    populateAllSubnodes(nodes, allSelectedNodes) {
        if (Array.isArray(nodes)) {
            nodes.forEach(i => {
                allSelectedNodes.push({ ...i });
                if (!this.props.splitParentAndChild && !this.props.splitOnlyParent) {
                    this.populateAllSubnodes(i.children, allSelectedNodes);
                }
            });
        }
    }

    selectAll = () => {
        let newMap = {};
        Object.keys(this.state.data.map).forEach(i => {
            newMap[i] = this.state.data.map[i];
            newMap[i].checked = newMap[i].isDefault === false ? false : true;
        });
        this.setState({ data: { ...this.state.data, map: newMap } });
        this.props.handleChange(Object.keys(this.state.data.map).map(i => { return { ...this.state.data.map[i] } }).filter(node => node.checked !== false && (node.children.length === 0 || this.props.splitOnlyParent)), []);
    }

    deselectAll = () => {
        let newMap = {};
        Object.keys(this.state.data.map).forEach(i => {
            newMap[i] = this.state.data.map[i];
            newMap[i].checked = false;
        });
        this.setState({ data: { ...this.state.data, map: newMap } });
        this.props.handleChange([], []);
    }

    onSelectDeselectAllChange = (value) => {
        value ? this.selectAll() : this.deselectAll();
    }

    handleNodeToggle = node => {
        let stateCopy = { ...this.state.data };
        let nodeInState = stateCopy.map[node.value];
        nodeInState.expanded = nodeInState.innerExpanded = node.expanded;
        if (node.expanded) {
            this.setExpanded(stateCopy.map[node.value].children, true);
        } else {
            this.setExpanded(stateCopy.map[node.value].children, false);
        }
        this.setState({ data: stateCopy });
    };

    setExpanded = (nodes, flag) => {
        if (Array.isArray(nodes)) {
            nodes.forEach(node => {
                if (flag && node.innerExpanded) {
                    node.expanded = true;
                    this.setExpanded(node.children, flag);
                } else if (!flag) {
                    node.expanded = false;
                    this.setExpanded(node.children, flag);
                }
            });
        }
    }
}

export default withLocalize(connect(
    state => state.domain
)(MultiSelect));